import { createI18n } from "vue-i18n";
import storage from "@/utils/storage.js";

// default lang
// import enUS from './lang/en-US'
import zhCN from "./lang/zh-CN.js";

export const defaultLang = "zh-CN";

const messages = {
  // 'en-US': {
  //   ...enUS
  // }
  "zh-CN": {
    ...zhCN
  }
};

const languageLoaders = {};

const i18n = createI18n({
  legacy: false,
  missingWarn: false,
  fallbackWarn: false,
  locale: defaultLang,
  fallbackLocale: defaultLang,
  messages
});

const loadedLanguages = [defaultLang];

function getCurrentLocale() {
  return typeof i18n.global.locale === "string" ? i18n.global.locale : i18n.global.locale.value;
}

function setI18nLanguage(lang) {
  if (typeof i18n.global.locale === "string") {
    i18n.global.locale = lang;
  } else {
    i18n.global.locale.value = lang;
  }
  // request.headers['Accept-Language'] = lang
  document.querySelector("html").setAttribute("lang", lang);
  return lang;
}

export async function loadLanguageAsync(lang = defaultLang) {
  // 缓存语言设置
  storage.set("lang", lang);

  if (getCurrentLocale() === lang) {
    return lang;
  }

  if (loadedLanguages.includes(lang)) {
    return setI18nLanguage(lang);
  }

  const loadLanguage = languageLoaders[lang];
  if (!loadLanguage) {
    throw new Error(`Language pack "${lang}" is not registered.`);
  }

  const msg = await loadLanguage();
  const locale = msg.default;
  i18n.global.setLocaleMessage(lang, locale);
  loadedLanguages.push(lang);
  return setI18nLanguage(lang);
}

export default i18n;
